import type { ParametroJsonFtvDTO } from '@/models/dto/fotovoltaico/parametro-json-ftv-dto'
import type { PhotovoltaicPropertyType } from '@/models/types/photovoltaic/photovoltaic-property-type'

const mapToPhotovoltaicPropertyType = (dto: ParametroJsonFtvDTO): PhotovoltaicPropertyType => {
    return {
        key: dto.name,
        type: dto.type,
        description: dto.description,
        label: dto.label,
        required: dto.required,
    }
}

const mapToParametroJsonDTO = (formData: PhotovoltaicPropertyType): ParametroJsonFtvDTO => {
    return {
        name: formData.key,
        type: formData.type,
        description: formData.description,
        label: formData.label,
        required: formData.required,
    }
}

export { mapToParametroJsonDTO, mapToPhotovoltaicPropertyType }
